import * as React from "react";

import "./userContactInfo.scss";

import {cs} from "@Common/react/chain-services";

import {CustomizationTile}    from "./customizationTile";
import {LabelAndInputContent} from "./labelAndInputContent";
import {UserContactInfoProps} from "../../build3";
import {SliderCheckbox}               from "@Common/ui-components/slider-checkbox/slider-checkbox";


export const UserContactInfo = ({userData, userLevel, agentEditDisplay, isDualAgent, domRef, branchEditAgentDisplay, formattingModal, setUnsavedChanges}: UserContactInfoProps) => cs(
    ["readOnlyVal", ({}, next) => next(userLevel === 5 ? !agentEditDisplay : userLevel === 4 ? !parseInt(branchEditAgentDisplay) : false)],
    ({readOnlyVal}) => (
        <div className="user-contact-info-6ld" ref={domRef}>
            <CustomizationTile
                header="User Contact Information"
                formattingModal={formattingModal}
                xdQaName="User Contact Information"
            >
                {!isDualAgent ?
                    <LabelAndInputContent
                        data={userData}
                        readOnly={readOnlyVal}
                        setUnsavedChanges={setUnsavedChanges}
                    />
                :
                    <>
                        <div xd-qa-type="card" xd-qa-name="User 1">
                            <h3 className="customization-tile-subheader" xd-qa-type="label" xd-qa-name="User 1 header">User 1</h3>
                            <LabelAndInputContent
                                data={userData.slice(0, Math.ceil(userData.length / 2))}
                                readOnly={readOnlyVal}
                                setUnsavedChanges={setUnsavedChanges}
                            />
                        </div>
                        <div xd-qa-type="card" xd-qa-name="User 2">
                            <hr />
                            <h3 className="customization-tile-title" xd-qa-type="label" xd-qa-name="User 2 header">User 2</h3>
                            <LabelAndInputContent
                                data={userData.slice(Math.ceil(userData.length / 2))}
                                readOnly={readOnlyVal}
                                setUnsavedChanges={setUnsavedChanges}
                            />
                        </div>
                    </>
                }
                { !readOnlyVal && (
                    <div className="default-user-contact-info">
                            <input
                                type="checkbox"
                                xd-qa-type="checkbox"
                                xd-qa-name="Save as default User Contact Information"
                                name="agentSaveDefault"
                                value={1}
                            /><div className="label">Save as default User Contact Information</div>
                    </div>)
                }
            </CustomizationTile>
        </div>
    )
);